import "./style.css";

import Modal from "react-modal";
import React, { useState, useEffect } from "react";
import CloseIcon from "assets/icons/actions/close.svg?react";
import Store from "./ModalStore";
import SaddleLogo from "assets/icons/saddleLogo.svg?react";

Modal.setAppElement("#root");

const ModalWrapper = (props) => {
  const {
    modalIsOpen,
    closeModal,
    title,
    shouldCloseOnOverlayClick = true,
    isCloseIcon = false,
    children,
    className,
    showHeader = false,
    titleClassName = "",
    style,
    /** When opening a modal on top of another (e.g. Add Horse over Book Fitting), raise above default overlay/content stacking. */
    overlayZIndex = 100,
    contentZIndex = 150,
  } = props;

  const [, setWasOpened] = useState(false);
  const [, setUid] = useState("");
  const [childrenVisible] = useState(true);

  useEffect(() => {
    setUid(getUid());
  }, []);

  const afterOpenModal = () => {
    setWasOpened(true);
  };

  const getUid = () => {
    return (
      "modal_" + Date.now().toString(36) + Math.random().toString(36).substr(2)
    );
  };

  const customStyles = {
    overlay: {
      zIndex: overlayZIndex,
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      zIndex: contentZIndex,
    },
  };

  return (
    <div
      onClick={() => {
        if (shouldCloseOnOverlayClick === true) {
          closeModal();
        }
      }}
    >
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        // onRequestClose={handleRequestClose}
        bodyOpenClassName="modal-open"
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        style={customStyles}
        contentLabel="Modal"
        closeTimeoutMS={300}
        className={`notification-modal`}
        overlayClassName={`${
          // location.pathname === "/buy"
          //   ? "notification-overlay backdrop-blur-[4px]"
          location.pathname === "/signup"
            ? "custom-overlay"
            : "notification-overlay"
          }`}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className={`notification-content no-scrollbar ${className}`}
        >
          {showHeader && <div className="bg-[#2b364b] w-[100%] rounded-tl-[12px] rounded-tr-[12px] p-[13px] flex items-center justify-between h-[51px] relative top-[-2px]">
            <SaddleLogo className="w-[149px] h-[51px]" />
            <CloseIcon className="cursor-pointer" onClick={closeModal} />
          </div>}

          <div style={style}>
            <div className={`notification-content__title ${titleClassName}`}>
              {title || children.title}
            </div>
            <div className="notification-content__body">
              <div className="notification-content-body">
                {childrenVisible && (
                  children?.content ? (
                    typeof children.content === 'function' ? (
                      <children.content />
                    ) : (
                      children.content
                    )
                  ) :
                    typeof children === 'function' ? (
                      children()
                    ) : (
                      children
                    )
                )}
              </div>
            </div>
            {isCloseIcon && (
              <div
                onClick={closeModal}
                className="notification-content__close-icon"
              >
                <CloseIcon></CloseIcon>
              </div>
            )}
          </div>
        </div>

      </Modal>
    </div>
  );
};

export const ReactModals = () => {
  const [state, setState] = useState([...Store.components]);

  useEffect(() => {
    Store.setUpdateHandler((components) => {
      setState(components);
    });
  }, []);

  return (
    <>
      {state.map((item, index) => {
        const ModalComponent = item.component;

        if (typeof ModalComponent === "object" && !ModalComponent?.render) {
          return <ModalComponent.type {...ModalComponent.props} key={index} />;
        }

        return <ModalComponent key={index}></ModalComponent>;
      })}
    </>
  );
};

export default ModalWrapper;
